
<div id="router-container" [ngStyle]="customService.getQuizContainerStyle()">
    <router-outlet (activate)="onActivate($event)" ></router-outlet>
    <p *ngIf="poweredByEnabled" class="company_dt" ><span i18n>Powered by</span> <a href="{{poweredbyUrl}}" target="_blank" i18n>Tangent AI</a></p>
</div>
